import Sortable from 'sortablejs';
import { baseSortableOptions } from 'helpers/sortable';
import ApplicationController from './application_controller';

// Drag-and-drop ordering for a list of nested fields (`link_to_add_fields` rows). Each row is a
// `[data-draggable="true"]` direct child with a `.drag-handle`, and carries a hidden
// `[data-sort-index-field]` input that receives its place in the list. The indexes are written after
// every drag and again on submit, so rows added after the last drag are numbered too.
export default class extends ApplicationController {
  connect() {
    this.sortable = new Sortable(this.element, {
      ...baseSortableOptions,
      handle: '.drag-handle',
      onEnd: this.onEnd.bind(this),
    });

    this.writeSortIndexes = this.writeSortIndexes.bind(this);
    this.form?.addEventListener('submit', this.writeSortIndexes);
  }

  disconnect() {
    this.sortable?.destroy();
    this.form?.removeEventListener('submit', this.writeSortIndexes);
  }

  onEnd({ oldIndex, newIndex }) {
    if (oldIndex === newIndex) return;

    this.writeSortIndexes();
    // `lib/warn_unsaved_changes` listens for this; don't bubble into other forms on the page.
    if (this.form) this.form.dispatchEvent(new CustomEvent('mark-dirty', { bubbles: false }));
  }

  writeSortIndexes() {
    const rows = Array.from(this.element.children).filter((row) => row.matches('[data-draggable="true"]'));
    rows.forEach((row, index) => {
      const field = row.querySelector('[data-sort-index-field]');
      if (field) field.value = index + 1;
    });
  }

  get form() {
    return this.element.closest('form');
  }
}
